import { render, staticRenderFns } from "./BusinessSettingsLayout.vue?vue&type=template&id=dc0dfe88&"
import script from "./BusinessSettingsLayout.vue?vue&type=script&lang=js&"
export * from "./BusinessSettingsLayout.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports